var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stats-card',{staticClass:"h13 metric",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Start Ratio ")]},proxy:true},{key:"content",fn:function(){return [_vm._v(" "+_vm._s(_vm.startRatio)+" % ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }